export enum IBusinessSettingsRouteEnum {
  BUSINESS_SETTINGS = "business-settings",
  GENERAL_SETTINGS = "business-settings.general-settings",
  PAYOUTS = "business-settings.payouts",
}
